<template>
  <div
    class="sidebar-item-container"
    @click="$emit('on-select', { ...option })"
  >
    <div
      class="side-bar-item d-flex align-items-center justify-content-center"
      :class="{ 'side-bar-item--active': option.id === selectedOption.id }"
    >
      <em class="side-bar-item__icon font-25" :class="option.icon" />
    </div>
    <span
      class="rounded-circle cursor-pointer side-bar-item__badge"
      :class="{
        'side-bar-item__badge--active': option.id === selectedOption.id,
      }"
      v-if="option.count"
    >
      {{ option.count }}
    </span>
    <div class="side-bar-item__separator"></div>
  </div>
</template>

<script>
export default {
  name: 'SideBarItem',
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    selectedOption: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/bootstrap/_colors.scss';
.side-bar-item {
  cursor: pointer;
  padding: 30px 0px 30px 0px;
  &__icon {
    color: #b5c3bc;
  }
  &__separator {
    border-bottom: 0.5px solid map-get($colors, 'green-5');
    margin-left: 7px;
    margin-right: 5px;
  }
  &__badge {
    position: absolute;
    background: blue 0% 0% no-repeat padding-box;
    color: #fff;
    width: 17px;
    height: 15px;
    opacity: 1;
    text-align: center;
    font-size: 10px;
    margin-top: -60px;
    &--active {
      background: #2db782 0% 0% no-repeat padding-box;
    }
  }
  &--active {
    background: map-get($colors, 'yellow-light-1');
    border-left: 5px solid map-get($colors, 'orange-light-2');
    border-right: 1px solid #dbdedf;
    em {
      color: map-get($colors, 'orange-light-2');
    }
  }
}
</style>
